// A realm's address is a pure function of its package path
// (gnovm/pkg/gnolang/misc.go DerivePkgCryptoAddr):
//
//   address = sha256("pkgPath:" + pkgPath)[:20], bech32 with prefix "g"
//
// The page needs it because wugnot.Approve wants the SPENDER's address, and
// the duel realm does not expose its own. duel.gno hard-codes two addresses
// derived the same way (gameRealmAddr, opsVaultAddr); test/addr.test.mjs
// checks this function reproduces both.
import { sha256 } from '@noble/hashes/sha2.js';
import { bech32 } from '@scure/base';

export function realmAddress(pkgPath) {
  if (!pkgPath) throw new Error('pkgPath cannot be empty');
  const digest = sha256(new TextEncoder().encode(`pkgPath:${pkgPath}`));
  return bech32.encode('g', bech32.toWords(digest.slice(0, 20)));
}
